export default __webpack_public_path__ + "static/product-rachio3-phone-e908d23ce62fab1d4a7a97df76135e31.png";